/// <reference path="../../_ext/Bases/GridBase.ts" />
namespace TabAurous.CRM {

    import fld = ProductCatalogRow.Fields;
    @Serenity.Decorators.registerClass()
    export class ProductCatalogGrid extends _Ext.GridBase<ProductCatalogRow, any> {
        protected getColumnsKey() { return 'CRM.ProductCatalog'; }
        protected getDialogType() { return <any>ProductCatalogDialog; }
        protected getIdProperty() { return ProductCatalogRow.idProperty; }
        protected getLocalTextPrefix() { return ProductCatalogRow.localTextPrefix; }
        protected getService() { return ProductCatalogService.baseUrl; }
        protected get_ExtGridOptions() { return Q.deepClone(q.DefaultMainGridOptions) }
        protected useViewMode() { return true; }
        //public initDialog(dialog: ProductCatalogDialog) {
        //    super.initDialog(dialog);
        //    dialog.parentGrid = this;
        //}
        constructor(container: JQuery) {
            super(container);
            var self = this;
            (this.view.params as TransactionRequest).InStock = false;
            self.setTitle('Product Catalog')
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            new _Ext.CardViewMixin({
                grid: this,
                itemTemplate: `
<table>
<tr>
<td rowspan="10" class="img"><img :src="getRandomImage(item)"/> </td>
</tr>
<tr>
<td class="name" style="font-size:15px;">
<a href="#"
@click.prevent="editItem(item)">
{{item.ProductName}}

</a>
</td>
</tr>
<tr>
<td class="name">
Pieces - {{item.Pieces}}
</td> 
<td class="name">
Weight - {{item.Weight}}
</td>
</tr>
<tr>
<td class="name" style="font-size:15px;font-color:blue;font-align:right">
Rate - {{item.Rate}}
</td> 
</tr>
<table>`,
                methods: {
                    editItem: function (item: ProductCatalogRow) {
                        self.editItem(item);
                    }, getRandomImage: function (item: ProductCatalogRow) { return Q.resolveUrl("~/upload/" + item.ImageName); }
                },
                defaultViewType: 'card'
            });
            
            this.slickGrid.setOptions({ rowHeight: 30 });
            return this;
        }
        private autoSize;
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize(); // *** If you want to make it autoresize when grid is loaded, use: new Slick.AutoColumnSize(true);
            grid.registerPlugin(this.autoSize);


            return grid;
        }

        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        // Excel Import
        protected getButtons(): Serenity.ToolButton[] {

            // call base method to get list of buttons
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            buttons.push({
                title: 'Show Products in Stock',
                cssClass: 'expand-all-button',
                onClick: () => {
                    (this.view.params as TransactionRequest).InStock = true;
                    this.refresh()
                }
            });
            Common.ProductSelectGrid
            return buttons;
        }
        protected onViewSubmit() {
            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideProducts && this.options.hideProducts.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["ProductID" /* ProductID */], 'not in', [this.options.hideProducts]]);
            return true;

        }
        protected getQuickFilters() {
            var filters = super.getQuickFilters();
            let self = this;

            //filters.push({
            //    type: Serenity.ServiceLookupEditor,
            //    options: {
            //        service: 'Stock/StockJewellery/List',
            //        idField: "ProductCode",
            //        textField: "ProductCode",
            //        multiple: true

            //    },
            //    field: 'ProductCode',
            //    title: 'Product',
            //    handler: w => {
            //        var temp = [];
            //        var values = w.value;
            //        for (var i = 0; i < values.length; i++) {
            //            temp.push((values[i]));
            //        } if (temp.length != 0) {
            //            (this.view.params as ReportFiltersRequest).ProductCodes = temp;
            //            //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
            //            //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
            //        } else if (temp.length == 0) {
            //            (this.view.params as ReportFiltersRequest).ProductCodes = temp;
            //        }
            //    },

            //    cssClass: 'hidden-xs'
            //});
            filters.push({
                type: Serenity.ServiceLookupEditor,
                options: {
                    service: 'CRM/ProductCatalog/BrandList',
                    idField: "BrandName",
                    textField: "BrandName",
                    multiple: true

                },
                field: 'BrandName',
                title: 'Brand',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push((values[i]));
                    } if (temp.length != 0) {
                        (self.view.params as TransactionRequest).ProductCodes = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    } else if (temp.length == 0) {
                        (self.view.params as TransactionRequest).ProductCodes = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.ServiceLookupEditor,
                options: {
                    service: 'CRM/ProductCatalog/CollectionList',
                    idField: "CollectionName",
                    textField: "CollectionName",
                    multiple: true

                },
                field: 'CollectionName',
                title: 'Collection',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push((values[i]));
                    } if (temp.length != 0) {
                        (self.view.params as TransactionRequest).ProductCodes = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    } else if (temp.length == 0) {
                        (self.view.params as TransactionRequest).ProductCodes = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.ServiceLookupEditor,
                options: {
                    service: 'CRM/ProductCatalog/SuperTypeList',
                    idField: "SuperTypeName",
                    textField: "SuperTypeName",
                    multiple: true

                },
                field: 'SuperTypeName',
                title: 'SuperType',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push((values[i]));
                    } if (temp.length != 0) {
                        (self.view.params as TransactionRequest).ProductCodes = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    } else if (temp.length == 0) {
                        (self.view.params as TransactionRequest).ProductCodes = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.ServiceLookupEditor,
                options: {
                    service: 'CRM/ProductCatalog/BOMShapeList',
                    idField: "ShapeId",
                    textField: "ShapeName",
                    multiple: true

                },
                field: 'ShapeName',
                title: 'Shape in Stones',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt((values[i])));
                    } if (temp.length != 0) {
                        (self.view.params as TransactionRequest).ShapeIds = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    } else if (temp.length == 0) {
                        (self.view.params as TransactionRequest).ShapeIds = null;
                    }
                },

                cssClass: 'hidden-xs'
            });
            filters.push({

                type: Serenity.DecimalEditor,
                options: {
                    service: '',
                    idField: 'Weight',
                    textField: 'Weight',
                    multiple: false
                },
                field: 'FromWeight',
                title: 'From Weight',
                handler: w => {
                    var weight = w.value;
                    (this.view.params as TransactionRequest).FromWeight = weight;
                },

                cssClass: 'hidden-xs'
            });
            filters.push({

                type: Serenity.DecimalEditor,
                options: {
                    service: '',
                    idField: 'Weight',
                    textField: 'Weight',
                    multiple: false
                },
                field: 'ToWeight',
                title: 'To Weight',
                handler: w => {
                    var weight = w.value;
                    (this.view.params as TransactionRequest).ToWeight = weight;
                },

                cssClass: 'hidden-xs'
            });

            filters.push({

                type: Serenity.DecimalEditor,
                options: {
                    service: '',
                    idField: 'Rate',
                    textField: 'Rate',
                    multiple: false
                },
                field: 'FromRate',
                title: 'From Rate',
                handler: w => {
                    var rate = w.value;
                    (this.view.params as TransactionRequest).FromRate = rate;
                },

                cssClass: 'hidden-xs'
            });
            filters.push({

                type: Serenity.DecimalEditor,
                options: {
                    service: '',
                    idField: 'Rate',
                    textField: 'Rate',
                    multiple: false
                },
                field: 'ToRate',
                title: 'To Rate',
                handler: w => {
                    var rate = w.value;
                    (this.view.params as TransactionRequest).ToRate = rate;
                },

                cssClass: 'hidden-xs'
            });
          
            return filters;
        }

        updateInterface() {
            super.updateInterface();

            if (!this.hasInsertPermission || this.readOnly) {
                this.toolbar.findButton('add-button').toggle(this.updateDisabledState());
                this.toolbar.findButton('import-xlsx-button').toggle(this.updateDisabledState());

            }
        }

    }
}